var exports = {
  "I": "x43aef4ae--5d2643--chips",
};

module.exports = exports;
